module.exports = __webpack_public_path__ + "img/bell-white.e25139ad.svg";